export type TopNewsBannerItemType = {
  link?: string
  textContent: string
  custom?: any
  data?: any
}

type TopNewsBannerType = {
  icon?: string
  newsTransitionDelay?: number
  customCssClass?: string
  closeIcon: React.ReactElement
  backgroundColor?: keyof typeof TopNewsBannerBackgroundColors
  newsItems?: Array<TopNewsBannerItemType>
}

export enum TopNewsBannerBackgroundColors {
  'black' = 'bg-black',
  'green' = 'bg-coffeeGreenDark',
  'brown' = 'bg-coffeeBrown',
  'jasmin_lightGreen' = 'bg-platinaGreen',
  'jasmin_darkGreen' = 'bg-pineGreen',
  'jasmin_red' = 'bg-teaFruit'
}

export default TopNewsBannerType
